import { MapPin } from "lucide-react";
import { useSiteContent } from "../../lib/siteContent";

export default function ServingGurgaon() {
  const site = useSiteContent();
  const serving = site.serving || {};
  const contact = site.contact || {};
  if (serving.enabled === false) return null;
  const title = serving.title || contact.serving_title || "Serving Gurgaon";
  const body = serving.body || contact.serving_body || "";
  const areas = String(serving.areas || "").split(",").map((s) => s.trim()).filter(Boolean);
  return (
    <section id="serving-gurgaon" data-testid="serving-gurgaon" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-gradient-to-br from-[#311b52] to-[#673c96] p-8 md:p-12 text-white">
          <MapPin className="w-8 h-8 text-[#f37721] mb-4" />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/70" style={{ fontFamily: "Montserrat" }}>{serving.eyebrow || "Coverage"}</span>
          <h2 className="text-3xl font-bold mt-2 mb-4" style={{ fontFamily: "Poppins" }}>{title}</h2>
          <p className="text-white/80 max-w-3xl leading-relaxed" style={{ fontFamily: "Montserrat" }}>{body}</p>
          {areas.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-6">
              {areas.map((a) => (
                <span key={a} className="px-3 py-1.5 rounded-full bg-white/10 text-sm">{a}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
